/**
 * Domain column indices for the Specifications spreadsheet. The numeric values match the cell
 * order the navigation hook (`useSpreadsheetNavigation`) operates on — 3 logical columns:
 * Name (Keys) | Value | Unit. Drag-handle and trash columns are visual-only `<td>`s outside this
 * enum because they are not keyboard-navigable.
 */
export enum GridColumn {
  Name = 0,
  Value = 1,
  Unit = 2,
}
